import {
  Grid, 
  TextField, 
  DialogContentText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Tooltip
} from '@mui/material';
import { PropTypes } from 'prop-types';
import { formatPhoneNumber, justNumbers } from '../utils/PhoneNumber';
import MRLocationSearch from './MRLocationSearch';
import InfoIcon from '@mui/icons-material/Info';

const STAGE = process.env.REACT_APP_MR_STAGE;

function LyftRideForm({
  rideData, 
  handleInputChange,
  setRideData,
  rideTimeIntervals,
  errors, 
}) {
  return (
    <Grid container item xs={8}>
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <TextField 
            fullWidth
            label="First Name" 
            variant="outlined"
            size="small"
            error={!!errors['firstName']}
            value={rideData.firstName}
            onChange={e => handleInputChange(setRideData)(e.target.value, 'firstName')}
            required
          />
        </Grid>
        <Grid item xs={3}>
          <TextField 
            fullWidth
            label="Last name" 
            variant="outlined"
            size="small"
            error={!!errors['lastName']}
            value={rideData.lastName}
            onChange={e => handleInputChange(setRideData)(e.target.value, 'lastName')}
            required
          />
        </Grid>
        <Grid item xs={3}>
          <TextField 
            fullWidth
            label="Rider's mobile phone number" 
            variant="outlined"
            size="small"
            error={!!errors['phoneNumber']}
            value={formatPhoneNumber(rideData.phoneNumber)}
            onChange={e => handleInputChange(setRideData)(justNumbers(e.target.value), 'phoneNumber')}
            required
            inputProps={{
              maxLength: 10
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <FormControl fullWidth size='small'>
            <InputLabel id="pickup-time-select-label">Pickup Time</InputLabel>
            <Select
              labelId="pickup-time-select-label"
              id="pickup-time-select"
              value={rideData.pickupTime}
              label="Pickup Time"
              onChange={e => handleInputChange(setRideData)(e.target.value, 'pickupTime')}
            >
              {rideTimeIntervals.map((time, index) => (
                <MenuItem key={index} value={time}>{time}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {
          ['dev'].includes(STAGE) && (
          <Grid item xs={4} className='flex items-center'>
            <Checkbox className='p-0 mr-2' value={rideData.isRoundTrip} onChange={e => handleInputChange(setRideData)(e.target.checked, 'isRoundTrip')} />
            <label className={`${!rideData.isRoundTrip && 'text-gray-500'}`}>Roundtrip ride</label>
            <Tooltip title="This option allows customers to request a return ride by SMS within a 48-hour limit.">
              <InfoIcon className='table-icon-info ml-1' fontSize='small'/>
            </Tooltip>
          </Grid>
          )
        }
      </Grid>
      <Grid container>
        <DialogContentText id="lyftDialog-description" className='break-words mt-2 mb-2 font-bold'>
          Enter pick-up address
        </DialogContentText>
        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12}>
            <MRLocationSearch 
              label="Pick-up address"
              variant="outlined"
              size="small"
              error={!!errors['pickupAddress']}
              value={rideData.pickupAddress.label}
              onSelect={e => handleInputChange(setRideData)(e, 'pickupAddress')}
            />
          </Grid>
        </Grid>
        <DialogContentText id="lyftDialog-description" className='break-words mt-4 mb-2 font-bold'>
          Enter drop-off address
        </DialogContentText>
        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12}>
            <MRLocationSearch 
              label="Drop-off address"
              variant="outlined"
              size="small"
              error={!!errors['dropOffAddress']}
              value={rideData.dropOffAddress.label}
              onSelect={e => handleInputChange(setRideData)(e, 'dropOffAddress')}
            />
          </Grid>
        </Grid>
      </Grid>
      <DialogContentText id="lyftDialog-description" className='break-words mt-4 mb-2 font-bold'>
        Enter request notes (internal use only)
      </DialogContentText>
      <Grid container spacing={2}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Internal note (optional)"
              variant="outlined"
              size="small"
              value={rideData.internalNote}
              onChange={e => handleInputChange(setRideData)(e.target.value, 'internalNote')}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Work Order #" 
              variant="outlined"
              size="small"
              value={rideData.WO}
              InputProps={{
                readOnly: true,
              }} 
              disabled
            />
          </Grid>
        </Grid>
      </Grid>     
    </Grid>
  )
} 

LyftRideForm.propTypes = {
  rideData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phoneNumber: PropTypes.string,
    pickupAddress: PropTypes.object,
    dropOffAddress: PropTypes.object,
    pickupTime: PropTypes.string,
    isRoundTrip: PropTypes.bool,
    internalNote: PropTypes.string,
    WO: PropTypes.string,
  }),
  handleInputChange: PropTypes.func,
  setRideData: PropTypes.func,
  rideTimeIntervals: PropTypes.array,
  errors: PropTypes.object
}

export default LyftRideForm;